module.exports = __webpack_public_path__ + "img/ico-filter-plus-white.40d82939.svg";